import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import { apiPutFetcher } from '@/common/api/fetcher'
import {
  ConnectInstagramResponse,
  ConnectInstagramVars,
  GetBrandSettingsResponse,
  GetBrandSettingsVars,
  GetInstagramStatusResponse,
  GetInstagramStatusVars,
  UgcApiPath,
  UpdateBrandSettingsResponse,
  UpdateBrandSettingsVars
} from '@/common/api/params/ugc'

/** ブランド設定（ブランド情報・Instagram の監視ハッシュタグ・同期頻度）の取得 */
export const useBrandSettingsApi = (vars: GetBrandSettingsVars | undefined) => {
  return useSWR<GetBrandSettingsResponse, Response, [string, GetBrandSettingsVars] | undefined>(
    vars ? [UgcApiPath.GET_BRAND_SETTINGS, vars] : undefined
  )
}

/** ブランド設定の更新。**PUT なので明示的に apiPutFetcher を渡す**（既定は POST） */
export const useUpdateBrandSettingsApi = (
  options?: MutationOptions<UpdateBrandSettingsResponse>
) => {
  return useCallMutation<UpdateBrandSettingsResponse, UpdateBrandSettingsVars>(
    UgcApiPath.UPDATE_BRAND_SETTINGS,
    options,
    apiPutFetcher
  )
}

/**
 * Instagram の接続状態。
 *
 * サーバ側は毎回 Graph API を叩いてアカウント情報を取り直すため、
 * 画面表示時の1回で足りる（フォーカス毎の再検証は既定で無効）。
 * トークンが期限切れの場合は `connected: false` と `error` が返る。
 */
export const useInstagramStatusApi = (vars: GetInstagramStatusVars | undefined) => {
  return useSWR<GetInstagramStatusResponse, Response, [string, GetInstagramStatusVars] | undefined>(
    vars ? [UgcApiPath.GET_INSTAGRAM_STATUS, vars] : undefined
  )
}

/**
 * Instagram の接続（アクセストークンと Business Account ID を保存する）。
 *
 * サーバ側は**保存の前に Graph API へ接続テストを行う**ので、
 * 成功が返った時点でトークンは実際に使える状態になっている。
 * トークンは暗号化して `ugc_brand_settings` に保存される。
 */
export const useConnectInstagramApi = (options?: MutationOptions<ConnectInstagramResponse>) => {
  return useCallMutation<ConnectInstagramResponse, ConnectInstagramVars>(
    UgcApiPath.CONNECT_INSTAGRAM,
    options
  )
}
